import React from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';

import CountryBar from './footer-countrybar';
import PopOver from './popover';
import Icon from './icon';
import ButtonIcon from './button-icon';
import Link from '../../../shared/components/hyperlink';

import './footer-desktop.less';

export const FooterDesktop = ({ footer, showCountries, onCloseCountries, onToggleCountries }) => {
    return (
        <div className="footer-desktop">
            <CountryBar onToggleCountries={onToggleCountries} countryFlagUrl={footer.countryFlagUrl} countryName={footer.countryName}>
                {showCountries && (
                    <PopOver show={showCountries} onClose={onCloseCountries} left={30} arrowBottom overlay>
                        <div className="country-container">
                            <div className="country-header">
                                <h3>Select Your Country/Region and Language</h3>
                                <ButtonIcon icon="icon-close" ariaLabel="Close Country Select" onClick={onCloseCountries} />
                            </div>
                            <div className="country-list-container">
                                <MetricsElement element="ul">
                                    {footer.countryList &&
                                        footer.countryList.map((country, countryKey) => (
                                            <li key={countryKey}>
                                                <Link to={country.countryUrl} key={` ${country.countryDataRegion}`}>
                                                    {country.countryTitle}
                                                </Link>
                                            </li>
                                        ))}
                                </MetricsElement>
                            </div>
                        </div>
                    </PopOver>
                )}
            </CountryBar>
            <MetricsElement element="div" className="links-container">
                {footer.groups.map((group, gkey) => (
                    <div className="links" key={gkey}>
                        <div className="title">
                            {group.link ? (
                                <Link
                                    data-metrics-event-name="linkClick"
                                    data-metrics-event={group.analyticsLinkType}
                                    data-metrics-link-id={group.analyticsLinkID}
                                    data-metrics-link-placement={'footer'}
                                    to={group.link}
                                >
                                    {group.name}
                                </Link>
                            ) : (
                                group.name
                            )}
                        </div>
                        <ul>
                            {group.items.map((item, itemKey) => (
                                <li key={itemKey}>
                                    <Link
                                        data-metrics-event-name="linkClick"
                                        data-metrics-event={item.analyticsLinkType}
                                        data-metrics-link-id={item.analyticsLinkID}
                                        data-metrics-link-placement={'footer'}
                                        to={item.link}
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
                <div className="links">
                    <div className="title">{footer.social.name}</div>
                    <div className="social">
                        {footer.social.items.map((item, itemKey) => (
                            <Link
                                data-metrics-event-name="linkClick"
                                data-metrics-event={item.analyticsLinkType}
                                data-metrics-link-id={item.analyticsLinkID}
                                data-metrics-link-placement={'footer'}
                                to={item.link}
                                key={itemKey}
                                aria-label={item.icon}
                            >
                                <Icon icon={item.icon} />
                            </Link>
                        ))}
                    </div>
                </div>
            </MetricsElement>
        </div>
    );
};

FooterDesktop.defaultProps = {
    showCountries: false,
};

FooterDesktop.propTypes = {
    /** footer data object */
    footer: PropTypes.object.isRequired,
    /** initial show countries state */
    showCountries: PropTypes.bool,
    /** close country content event */
    onCloseCountries: PropTypes.func.isRequired,
    /** toggle country content */
    onToggleCountries: PropTypes.func.isRequired,
};

export default FooterDesktop;
